import {useEffect, useRef} from 'react';
import {useDispatch, useStore} from 'react-redux';

export default function usePrefetchOnIdle(prefetchers = [], {
    timeout = 2000, delay = 0, enabled = true
} = {}) {
    const dispatch = useDispatch();
    const store = useStore();
    const hasRunRef = useRef(false);

    useEffect(() => {
        if (!enabled || hasRunRef.current) return undefined;
        if (typeof window === 'undefined') return undefined;

        const schedule = window.requestIdleCallback || ((cb) => setTimeout(() => cb(), 1));
        const cancel = window.cancelIdleCallback || clearTimeout;

        let idleHandle;
        const delayHandle = setTimeout(() => {
            idleHandle = schedule(() => {
                hasRunRef.current = true;
                prefetchers.forEach(({shouldFetch, action}) => {
                    try {
                        const state = store.getState();
                        if (typeof shouldFetch === 'function' && !shouldFetch(state)) return;
                        const result = dispatch(action());
                        if (result && typeof result.catch === 'function') {
                            result.catch(() => null);
                        }
                    } catch {
                        // swallow — prefetch is best-effort
                    }
                });
            }, {timeout});
        }, delay);

        return () => {
            clearTimeout(delayHandle);
            if (idleHandle !== undefined) cancel(idleHandle);
        };
    }, [enabled]);
}
